import { render } from "./ChangeWorkerPassword.vue?vue&type=template&id=2377ce86&scoped=true"
import script from "./ChangeWorkerPassword.vue?vue&type=script&lang=js"
export * from "./ChangeWorkerPassword.vue?vue&type=script&lang=js"

import "./ChangeWorkerPassword.vue?vue&type=style&index=0&id=2377ce86&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2377ce86"]])

export default __exports__